import type { ReactNode } from 'react'

type TelegramShellProps = {
  theme: 'light' | 'dark'
  children: ReactNode
}

export const TelegramShell = ({ theme, children }: TelegramShellProps) => (
  <div className={`app-shell app-shell--telegram app-shell--${theme}`}>{children}</div>
)
